import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInternet = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Browser_Internet_Web_Network_Lock",
	"data-name": "Browser, Internet, Web, Network, Lock",
	xmlns: "http://www.w3.org/2000/svg",
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "Group_16339",
		"data-name": "Group 16339",
		transform: "translate(3.333 5)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12357",
				"data-name": "Path 12357",
				d: "M32,33H5.333A3.332,3.332,0,0,1,2,29.667V6.333A3.332,3.332,0,0,1,5.333,3H32a3.332,3.332,0,0,1,3.333,3.333V29.667A3.332,3.332,0,0,1,32,33Z",
				transform: "translate(-2 -3)",
				fill: "none",
				stroke: "#656565",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12358",
				"data-name": "Path 12358",
				d: "M2,8H35.333",
				transform: "translate(-2 0.333)",
				fill: "none",
				stroke: "#656565",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12359",
				"data-name": "Path 12359",
				d: "M4.782,5.49a.008.008,0,1,0,.008.008.008.008,0,0,0-.008-.008",
				transform: "translate(-0.151 -1.34)",
				fill: "none",
				stroke: "#656565",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12360",
				"data-name": "Path 12360",
				d: "M7.325,5.49a.008.008,0,0,0-.008.008.009.009,0,0,0,.008.008.008.008,0,1,0,0-.017",
				transform: "translate(1.545 -1.34)",
				fill: "none",
				stroke: "#656565",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12361",
				"data-name": "Path 12361",
				d: "M9.864,5.49a.008.008,0,1,0,.008.008.008.008,0,0,0-.008-.008",
				transform: "translate(3.237 -1.34)",
				fill: "none",
				stroke: "#656565",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12362",
				"data-name": "Path 12362",
				d: "M15.989,16V13.85a2.872,2.872,0,0,0-3.845-2.668,2.96,2.96,0,0,0-1.853,2.807V16",
				transform: "translate(3.527 2.334)",
				fill: "none",
				stroke: "#656565",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12363",
				"data-name": "Path 12363",
				d: "M17.333,19.833H10.667A1.667,1.667,0,0,1,9,18.167v-2.5A1.667,1.667,0,0,1,10.667,14h6.667A1.667,1.667,0,0,1,19,15.667v2.5A1.667,1.667,0,0,1,17.333,19.833Z",
				transform: "translate(2.667 4.333)",
				fill: "none",
				stroke: "#656565",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			})
		]
	}), /* @__PURE__ */ _jsx("path", {
		id: "Path_12364",
		"data-name": "Path 12364",
		d: "M0,0H40V40H0Z",
		fill: "none"
	})]
});
export default SvgInternet;
